import { createContext } from 'react';

import { FollowingContextType } from 'utils/types';

const FollowingContext = createContext<FollowingContextType>({
  following: [],
  getFollowing: async (): Promise<void> => {},
  follow: async (): Promise<void> => {},
  unfollow: async (): Promise<void> => {},
});

export default FollowingContext;
